export const VIDEO_TYPE = 'Vídeo'
export const GIF_TYPE = 'GIF'

export const MEDIA_TYPES = [VIDEO_TYPE, GIF_TYPE]

export const MEDIA_TYPES_PROPS = {
  [VIDEO_TYPE]: {
    icon: 'ondemand_video',
    label: VIDEO_TYPE
  },
  [GIF_TYPE]: {
    icon: 'gif',
    label: GIF_TYPE
  }
}

export const BOLETOS_CATEGORY = 'Boletos'
export const STATEMENTS_CATEGORY = 'Extratos'
export const R_FACTOR_CATEGORY = 'Fator R'
export const IRPF_CATEGORY = 'IRPF'
export const LICENSE_CATEGORY = 'Licenciamento de PJ'
export const CASH_BOOK_CATEGORY = 'Livro Caixa'
export const INVOICES_CATEGORY = 'Notas Fiscais'
export const PODCASTS_CATEGORY = 'Podcasts'
export const REGISTER_CATEGORY = 'Registro de PJ'
export const TAXES_CATEGORY = 'Tributos'
export const OTHERS_CATEGORY = 'Outros'

export const MEDIA_CATEGORIES = [
  INVOICES_CATEGORY,
  BOLETOS_CATEGORY,
  STATEMENTS_CATEGORY,
  CASH_BOOK_CATEGORY,
  IRPF_CATEGORY,
  REGISTER_CATEGORY,
  LICENSE_CATEGORY,
  PODCASTS_CATEGORY,
  R_FACTOR_CATEGORY,
  TAXES_CATEGORY,
  OTHERS_CATEGORY
]

export const MEDIA_CATEGORIES_PROPS = {
  [BOLETOS_CATEGORY]: {
    color: 'orange',
    icon: 'request_quote'
  },
  [STATEMENTS_CATEGORY]: {
    color: 'cyan',
    icon: 'receipt'
  },
  [R_FACTOR_CATEGORY]: {
    color: 'teal',
    icon: 'calculate'
  },
  [IRPF_CATEGORY]: {
    color: 'blue',
    icon: 'currency_exchange'
  },
  [LICENSE_CATEGORY]: {
    color: 'pink',
    icon: 'note_alt'
  },
  [CASH_BOOK_CATEGORY]: {
    color: 'cyan-10',
    icon: 'menu_book'
  },
  [INVOICES_CATEGORY]: {
    color: 'green',
    icon: 'receipt_long'
  },
  [PODCASTS_CATEGORY]: {
    color: 'light-green',
    icon: 'mic'
  },
  [REGISTER_CATEGORY]: {
    color: 'indigo',
    icon: 'document_scanner'
  },
  [TAXES_CATEGORY]: {
    color: 'amber',
    icon: 'account_balance'
  },
  [OTHERS_CATEGORY]: {
    color: 'grey-7',
    icon: 'category'
  }
}

export const CONTENTS_LOCAL = 'Conteúdos'
export const TUTORIALS_LOCAL = 'Tutoriais'

export const MEDIA_LOCAL_OPTIONS = [
  CONTENTS_LOCAL,
  TUTORIALS_LOCAL
]

export const MEDIA_LOCAL_PROPS = {
  [CONTENTS_LOCAL]: {
    color: 'blue-grey'
  },
  [TUTORIALS_LOCAL]: {
    color: 'light-blue'
  }
}

export const IS_VISIBLE_OPTIONS = [
  { label: 'Visível', value: true },
  { label: 'Oculto', value: false }
]

export const IS_VISIBLE_PROPS = {
  [true]: {
    label: 'Visível',
    icon: 'visibility',
    color: 'positive'
  },
  [false]: {
    label: 'Oculto',
    icon: 'visibility_off',
    color: 'grey'
  }
}

export const DEFAULT_MEDIA = {
  title: '',
  type: '',
  url: '',
  file: null,
  category: '',
  local: '',
  is_visible: false,
  is_fixed: false,
  related_media: [],
  tags: []
}

export const PLAYLIST_IS_ACTIVE_OPTIONS = [
  { label: 'Ativa', value: true },
  { label: 'Inativa', value: false }
]

export const PLAYLIST_IS_ACTIVE_PROPS = {
  [false]: {
    label: 'Inativa',
    color: 'red-6'
  },
  [true]: {
    label: 'Ativa',
    color: 'positive'
  }
}

export const DEFAULT_PLAYLIST = {
  title: '',
  thumbnail: null,
  local: '',
  is_active: false
}
